import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getBusSchedule(options) {
    const response = Api().post(apiPath.schedule.bus, options);
    return response;
  },

  getAirArrivalSchedule(options) {
    const response = Api().get(apiPath.schedule.air + "arrival", options);
    return response;
  },

  getAirDepartureSchedule(options) {
    const response = Api().get(apiPath.schedule.air + "departure", options);
    return response;
  },

  getBusLines() {
    const response = Api().post(apiPath.schedule.bus_lines);
    return response;
  },
  getBusLineDetail(line_id, line_direction) {
    const response = Api().post(
      apiPath.schedule.bus_line_detail + line_id + "/" + line_direction
    );
    return response;
  }
};
